import React from "react";
import SellerDetailsForm from "./Seller Details Form/SellerDetailsForm";
import SellerManagementDetails from "./Seller Management Details/SellerManagementDetails";
import SellerBasicDetails from "./Seller Basic Details/SellerBasicDetails";
import GeoDetails from "./Geo Details/GeoDetails";
import ExecutivesDetails from "./Executives/ExecutivesDetails";
import OtherBusinessDetails from "./Other Business Details/OtherBusinessDetails";
import FileAttachments from "./File Attachements/FileAttachements";
import Security from "./Security/Security";

export default function Form_Settings() {
  return (
    <div className="border-2 border-gray-200 rounded-xl">
      <div className="border-b-2 border-gray-200 p-5 flex items-center justify-between">
        <div className="font-semibold text-gray-600 text-xl">Form Settings</div>
        <div>
          <button className="text-white bg-gray-800 px-3 py-1 text-md font-semibold rounded-lg">
            Update
          </button>
        </div>
      </div>
      <div>
        <SellerDetailsForm />
        <SellerManagementDetails />
        <SellerBasicDetails />
        <GeoDetails />
        <ExecutivesDetails />
        <OtherBusinessDetails />
        <FileAttachments />
        <Security />
      </div>
    </div>
  );
}
